import React, { useReducer } from "react";
// import axios from "axios";
import axios from "../../axiosinstance";
import ParameterContext from "./ParameterContext";
import ParameterReducer from "./ParameterReducer";
import {
  GET_BEMOB_SETUP,
  GET_CHECKOUT_LANGUAGES,
  GET_BEMOB_COUNTRY,
  GET_USER_GROUP,
  GET_SHOPIFY_MENU_LIST,
  COLOR_CODE,
  POSTING_STORE,
  OWNER_STORE,
  PARAMETER_ERROR,
  GET_DOMAIN_LIST
} from "../types";

const ParameterState = (props) => {
  const initialState = {
    bemob_setup_list: null,
    checkout_languages: null,
    bemob_country: null,
    user_group: null,
    shopify_menu_list: null,
    domain_list: null,
    color_code: null,
    posting_store: null,
    owner_store: null,
    error: null,
  };

  const [state, dispatch] = useReducer(ParameterReducer, initialState);

  const getBemobSetupList = async () => {
    try {
      const res = await axios.get("/api/parameters/bemob_setup");

      dispatch({
        type: GET_BEMOB_SETUP,
        payload: res.data,
      });
    } catch (err) {
      dispatch({
        type: PARAMETER_ERROR,
        payload: err.response,
      });
    }
  };

  const getCheckoutLanguages = async () => {
    try {
      const res = await axios.get("/api/parameters/checkout_languages");

      dispatch({
        type: GET_CHECKOUT_LANGUAGES,
        payload: res.data,
      });
    } catch (err) {
      dispatch({
        type: PARAMETER_ERROR,
        payload: err.response,
      });
    }
  };

  const getDomainList = async () => {
    try {
      const res = await axios.get("/api/domain");

      dispatch({
        type: GET_DOMAIN_LIST,
        payload: res.data,
      });
    } catch (err) {
      dispatch({
        type: PARAMETER_ERROR,
        payload: err.response,
      });
    }
  };

  const getBemobCountry = async () => {
    try {
      const res = await axios.get("/api/parameters/bemob_country");

      dispatch({
        type: GET_BEMOB_COUNTRY,
        payload: res.data,
      });
    } catch (err) {
      dispatch({
        type: PARAMETER_ERROR,
        payload: err.response,
      });
    }
  };

  const getUserGroup = async () => {
    try {
      const res = await axios.get("/api/parameters/user_group");

      dispatch({
        type: GET_USER_GROUP,
        payload: res.data,
      });
    } catch (err) {
      dispatch({
        type: PARAMETER_ERROR,
        payload: err.response,
      });
    }
  };

  const getShopifyMenuList = async () => {
    try {
      let data = `
      {
        'title': 'Shopify',
        'name': 'Campaign',
        'link': '/campaign'
      },
      {
          'title': 'Shopify',
          'name': 'Report',
          'link': '/report'
      },
      {
          'title': 'Shopify',
          'name': 'Domain',
          'link': '/domain'
      },
      {
          'title': 'Facebook',
          'name': 'Profile',
          'link': '/facebook/profile'
      }`

      dispatch({
        type: GET_SHOPIFY_MENU_LIST,
        payload: data,
      });
      
    } catch (err) {
      dispatch({
        type: PARAMETER_ERROR,
        payload: err.response,
      });
    }
  };

  const getColorCode = async () => {
    try {
      const res = await axios.get("/api/parameters/color_code");

      dispatch({
        type: COLOR_CODE,
        payload: res.data,
      });
    } catch (err) {
      dispatch({
        type: PARAMETER_ERROR,
        payload: err.response,
      });
    }
  };

  const setColorCode = async (params) => {
    try {
      const res = await axios.post("/api/parameters/color_code", {
        params,
      });

      dispatch({
        type: COLOR_CODE,
        payload: res.data,
      });
    } catch (err) {
      dispatch({
        type: PARAMETER_ERROR,
        payload: err.response,
      });
    }
  };

  const getPostingStore = async () => {
    try {
      const res = await axios.get("/api/parameters/posting_store");

      dispatch({
        type: POSTING_STORE,
        payload: res.data,
      });
    } catch (err) {
      dispatch({
        type: PARAMETER_ERROR,
        payload: err.response,
      });
    }
  };

  const getOwnerStore = async () => {
    try {
      const res = await axios.get("/api/parameters/owner_store");

      dispatch({
        type: OWNER_STORE,
        payload: res.data,
      });
    } catch (err) {
      dispatch({
        type: PARAMETER_ERROR,
        payload: err.response,
      });
    }
  };

  return (
    <ParameterContext.Provider
      value={{
        bemob_setup_list: state.bemob_setup_list,
        checkout_languages: state.checkout_languages,
        bemob_country: state.bemob_country,
        user_group: state.user_group,
        shopify_menu_list: state.shopify_menu_list,
        domain_list: state.domain_list,
        color_code: state.color_code,
        posting_store: state.posting_store,
        owner_store: state.owner_store,
        getBemobSetupList,
        getCheckoutLanguages,
        getBemobCountry,
        getUserGroup,
        getShopifyMenuList,
        getDomainList,
        getColorCode,
        setColorCode,
        getPostingStore,
        getOwnerStore,
      }}
    >
      {props.children}{" "}
    </ParameterContext.Provider>
  );
};
export default ParameterState;
